export default __webpack_public_path__ + "static/media/accountsettingdashboard.42bcbdc1.svg";